import { Drawer } from "antd";
import SelectSlot from "./SelectSlot";
import close from "../../../../assets/images/close.svg";
import "./SelectSlot.css";
import { getLocalStorage } from "../../../../utils/localStorage";
import {
  LangSpecificMsg,
  LANGUAGE,
} from "../../../symptomCollector/utils/constants";
import { ValidLanguages } from "../../../symptomCollector/utils/types";

const SelectSlotDrawer = ({
  closeDrawer,
  handleSelectedOptions,
  selectedDoctor,
  agentDetails,
}: any) => {
  const selectedLanguage = getLocalStorage(LANGUAGE);
  const LangSpecificMsgData =
    LangSpecificMsg[(selectedLanguage as ValidLanguages) || "english"];

  return (
    <Drawer
      placement="bottom"
      onClose={closeDrawer}
      closeIcon={false}
      open={true}
      height="auto"
      className="rounded-t-2xl overflow-hidden p-0 max-w-[450px] mx-auto"
      push={false}
    >
      <div className="flex justify-between items-center pb-2">
        <div className="font-semibold text-lg">
          {LangSpecificMsgData.selectSlot}
        </div>
        <img src={close} alt="close" onClick={closeDrawer} />
      </div>
      <SelectSlot
        handleSelectedOptions={(value: any) => {
          handleSelectedOptions(value, "slots");
          closeDrawer();
        }}
        selectedDoctor={selectedDoctor}
        agentDetails={agentDetails}
      />
    </Drawer>
  );
};

export default SelectSlotDrawer;
